import { render, staticRenderFns } from "./LoadingOrdineDettaglio.vue?vue&type=template&id=44b3b472"
import script from "./LoadingOrdineDettaglio.vue?vue&type=script&lang=ts"
export * from "./LoadingOrdineDettaglio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b3b472')) {
      api.createRecord('44b3b472', component.options)
    } else {
      api.reload('44b3b472', component.options)
    }
    module.hot.accept("./LoadingOrdineDettaglio.vue?vue&type=template&id=44b3b472", function () {
      api.rerender('44b3b472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-templates/LoadingOrdineDettaglio.vue"
export default component.exports